import { getUserBaseInfo } from "@/service/rapyd.service";
import DepositContext, { DepositContentProps } from "@/utils/depositContext";
import React, { useEffect, useState } from "react";
import RFLayout from "@/layout/RFLayout";
import Toast from "@/components/Toast";
import rfLocalStore from "@/utils/rfLocalStore";
import rfStore from "@/utils/rfStore";
import { useRouter } from "next/router";

interface DepositLayoutProps {
	children: React.ReactNode;
}

export default function DepositLayout({ children }: DepositLayoutProps) {
	const router = useRouter();
	const [depositInfo, setDepositInfo] = useState<DepositContentProps>();

	useEffect(() => {
		genDepositInfo();
	}, []);

	const genDepositInfo = async () => {
		try {
			let currency = "";
			let price = 0;

			const localStore = rfLocalStore.getDeposit();
			if (localStore) {
				if (localStore.price) {
					price = localStore.price;
				}
				if (localStore.currency) {
					currency = localStore.currency;
				}
			}

			if (router.query.currency) {
				currency = String(router.query.currency);
			}
			if (router.query.amount) {
				price = Number(router.query.amount);
			}

			if (!currency || !price) throw Error("Missing currency or price");

			// 接口获取
			const data = await getUserBaseInfo();
			if (!data) throw Error("Missing User Infos");

			const { masterAccountNameLocal, email, region } = data;

			setDepositInfo({
				currency,
				price,
				email,
				defaultRegion: rfStore.getRFState()?.region || region,
				name: masterAccountNameLocal,
			});
		} catch (error: any) {
			Toast.fail(error.message);
		}
	};

	return (
		<RFLayout>
			<DepositContext.Provider value={depositInfo}>{children}</DepositContext.Provider>
		</RFLayout>
	);
}
